<template>
  <slot name="search"></slot>
  <slot name="form" :searchItem="searchItem"></slot>
  <slot name="icon"></slot>
</template>

<script>
export default {
  name: "SearchBar",

  data() {
    let searchUrl = this.getSearchUrl();
    return {
      searchItem: '',
      checkSearched: searchUrl.searchParams.get("search") ? searchUrl.searchParams.get("search") : "",
      active: false
    }
  },

  props: {
    mobileSearch: String
  },

  methods: {
    handleSubmit(search) {
      let searchUrl = this.getSearchUrl();

      searchUrl.searchParams.set("search", search)
      this.searchItem = search

      window.location = decodeURIComponent(searchUrl.href)
    },

    getSearchUrl() {
      return new URL(window.location.origin.toString() + "/onderzoeken/");
    },

    changeState: function () {
      const mobile = document.getElementById(this.mobileSearch)

      this.active = !this.active

      this.active ?
        mobile.classList.add('active') :
        mobile.classList.remove('active')
    }
  }
}
</script>
